import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';
import { insertFullName } from 'api/cuentaunicasir';

export const baseURI = '/empresas/contribuyentes/';

/**
 * GET Contribuyentes
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getContribuyentes = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    response.data.results = formatReceived(insertFullName(response.data.results));
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Contribuyente
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getContribuyente = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(insertFullName(response.data));
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Contribuyente
  * @param {Object} values
 * @returns {Promise<Object>}
 */
export const postContribuyente = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Contribuyente
 * @param {number} id
 * @param {Object} values
 * @returns {Promise<Object>}
 */
export const patchContribuyente = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Contribuyente
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const deleteContribuyente = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const getContribuyenteCaja = async (params = {}) => {
  try {
    const response = await API.get('empresas/contribuyentes-caja', { params });
    const results = response.data.results.map((c) => ({ ...c, clave_ciudadana: c.clave }));
    return { ...formatReceived(response.data), results: formatReceived(results) };
  } catch (err) {
    onError(err);
    return [];
  }
};
